import b4w from "./src/util/b4w.js";
import m_app from "./src/addons/app.js";
import m_camera_anim from "./src/addons/camera_anim.js";
import m_fps from "./src/addons/fps.js";
import m_gp_conf from "./src/addons/gp_conf.js";
import m_gyroscope from "./src/addons/gyroscope.js";
import m_hmd from "./src/addons/hmd.js";
import m_hmd_conf from "./src/addons/hmd_conf.js";
import m_mixer from "./src/addons/mixer.js";
import m_mouse from "./src/addons/mouse.js";
import m_npc_ai from "./src/addons/npc_ai.js";
import m_preloader from "./src/addons/preloader.js";
import m_screenshooter from "./src/addons/screenshooter.js";
import m_storage from "./src/addons/storage.js";
import m_anchors from "./src/extern/anchors.js";
import m_animation from "./src/extern/animation.js";
import m_armature from "./src/extern/armature.js";
import m_assets from "./src/extern/assets.js";
import m_camera from "./src/extern/camera.js";
import m_config from "./src/extern/config.js";
import m_constraints from "./src/extern/constraints.js";
import m_container from "./src/extern/container.js";
import m_controls from "./src/extern/controls.js";
import m_data from "./src/extern/data.js";
import m_debug from "./src/extern/debug.js";
import m_geometry from "./src/extern/geometry.js";
import m_hud from "./src/extern/hud.js";
import m_input from "./src/extern/input.js";
import m_lights from "./src/extern/lights.js";
import m_logic_nodes from "./src/extern/logic_nodes.js";
import m_main from "./src/extern/main.js";
import m_material from "./src/extern/material.js";
import m_math from "./src/extern/math.js";
import m_nla from "./src/extern/nla.js";
import m_objects from "./src/extern/objects.js";
import m_particles from "./src/extern/particles.js";
import m_physics from "./src/extern/physics.js";
import m_rgb from "./src/extern/rgb.js";
import m_scenes from "./src/extern/scenes.js";
import m_screen from "./src/extern/screen.js";
import m_sfx from "./src/extern/sfx.js";
import m_textures from "./src/extern/textures.js";
import m_time from "./src/extern/time.js";
import m_transform from "./src/extern/transform.js";
import m_tsr from "./src/extern/tsr.js";
import m_util from "./src/extern/util.js";
import m_version from "./src/extern/version.js";

// legacy exeption
import m_print from "./src/intern/print.js";

b4w.app = m_app;
b4w.camera_anim = m_camera_anim;
b4w.fps = m_fps;
b4w.gp_conf = m_gp_conf;
b4w.gyroscope = m_gyroscope;
b4w.hmd = m_hmd;
b4w.hmd_conf = m_hmd_conf;
b4w.mixer = m_mixer;
b4w.mouse = m_mouse;
b4w.npc_ai = m_npc_ai;
b4w.preloader = m_preloader;
b4w.screenshooter = m_screenshooter;
b4w.storage = m_storage;
b4w.anchors = m_anchors;
b4w.animation = m_animation;
b4w.armature = m_armature;
b4w.assets = m_assets;
b4w.camera = m_camera;
b4w.config = m_config;
b4w.constraints = m_constraints;
b4w.container = m_container;
b4w.controls = m_controls;
b4w.data = m_data;
b4w.debug = m_debug;
b4w.geometry = m_geometry;
b4w.hud = m_hud;
b4w.input = m_input;
b4w.lights = m_lights;
b4w.logic_nodes = m_logic_nodes;
b4w.main = m_main;
b4w.material = m_material;
b4w.math = m_math;
b4w.nla = m_nla;
b4w.objects = m_objects;
b4w.particles = m_particles;
b4w.physics = m_physics;
b4w.rgb = m_rgb;
b4w.scenes = m_scenes;
b4w.screen = m_screen;
b4w.sfx = m_sfx;
b4w.textures = m_textures;
b4w.time = m_time;
b4w.transform = m_transform;
b4w.tsr = m_tsr;
b4w.util = m_util;
b4w.version = m_version;
b4w.print = m_print;




// import _m_anchors from "./anchors.js";
// import _m_animation from "./animation.js";
// import _m_armature from "./armature.js";
// import _m_assets from "./assets.js";
// import _m_batch from "./batch.js";
// import _m_boundings from "./boundings.js";
// import _m_camera from "./camera.js";
// import _m_compat from "./compat.js";
// import _m_config from "./config.js";
// import _m_constraints from "./constraints.js";
// import _m_container from "./container.js";
// import _m_controls from "./controls.js";
// import _m_curve from "./curve.js";
// import _m_data from "./data.js";
// import _m_debug from "./debug.js";
// import _m_extensions from "./extensions.js";
// import _m_geometry from "./geometry.js";
// import _m_graph from "./graph.js";
// import _m_hud from "./hud.js";
// import _m_input from "./input.js";
// import _m_ipc from "./ipc.js";
// import _m_lights from "./lights.js";
// import _m_loader from "./loader.js";
// import _m_logic_nodes from "./logic_nodes.js";
// import _m_main from "./main.js";
// import _m_math from "./math.js";
// import _m_navmesh from "./navmesh.js";
// import _m_nla from "./nla.js";
// import _m_nodemat from "./nodemat.js";
// import _m_obj_util from "./obj_util.js";
// import _m_objects from "./objects.js";
// import _m_particles from "./particles.js";
// import _m_physics from "./physics.js";
// import _m_prerender from "./prerender.js";
// import _m_primitives from "./primitives.js";
// import _m_print from "./print.js";
// import _m_reformer from "./reformer.js";
// import _m_renderer from "./renderer.js";
// import _m_scenegraph from "./scenegraph.js";
// import _m_scenes from "./scenes.js";
// import _m_sfx from "./sfx.js";
// import _m_shaders from "./shaders.js";
// import _m_subscene from "./subscene.js";
// import _m_tbn from "./tbn.js";
// import _m_texcomp from "./texcomp.js";
// import _m_textures from "./textures.js";
// import _m_time from "./time.js";
// import _m_transform from "./transform.js";
// import _m_tsr from "./tsr.js";
// import _m_util from "./util.js";
// import _m_version from "./version.js";

import * as m_vec3 from "./src/libs/gl_matrix/vec3.js";
import * as m_vec4 from "./src/libs/gl_matrix/vec4.js";
import * as m_mat3 from "./src/libs/gl_matrix/mat3.js";
import * as m_mat4 from "./src/libs/gl_matrix/mat4.js";
import * as m_quat from "./src/libs/gl_matrix/quat.js";
b4w.vec3 = m_vec3;
b4w.vec4 = m_vec4;
b4w.mat3 = m_mat3;
b4w.mat4 = m_mat4;
b4w.quat = m_quat;

// TODO: fix the next lines
b4w.register("vec3", function(exports, require){for (var i in m_vec3) exports[i] = m_vec3[i];});
b4w.register("vec4", function(exports, require){for (var i in m_vec4) exports[i] = m_vec4[i];});
b4w.register("mat3", function(exports, require){for (var i in m_mat3) exports[i] = m_mat3[i];});
b4w.register("mat4", function(exports, require){for (var i in m_mat4) exports[i] = m_mat4[i];});
b4w.register("quat", function(exports, require){for (var i in m_quat) exports[i] = m_quat[i];});

export default b4w;